var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfo = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "currentColor",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0m0 22a10 10 0 1 1 10-10 10 10 0 0 1-10 10",
  className: "cls-1"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M14 12v-2H8v2h1v7h6v-2h-1Zm-3 5v-5h1v5ZM11.5 9A2.5 2.5 0 1 0 9 6.5 2.5 2.5 0 0 0 11.5 9m0-3a.5.5 0 1 1-.5.5.5.5 0 0 1 .5-.5",
  className: "cls-1"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/info.7f4e40b1801dcde87ee0bc304ada6919.svg";